/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useRef } from "react";
import Button from "react-bootstrap/Button";
import { Icon } from "@iconify/react";
import { useForm, ValidationError } from "@formspree/react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";

function ContactForm() {
  const [state, handleSubmit] = useForm("xwkdbwpy");
  if (state.succeeded) {
    return (
      <div>
        <p className="submission-text">Thank you for message!</p>
        <p className="submission-text">We would contact you soon!</p>
      </div>
    );
  }
  return (
    <form onSubmit={handleSubmit}>
      <div className="contact-form d-flex flex-column form-floating">
        <div className="first-row d-flex">
          <div className="form-floating mb-3">
            <input
              id="name"
              name="name"
              type="text"
              className="form-control"
              placeholder="John Doe"
              required
            />
            <label htmlFor="floatingInputValue">Name</label>
            <ValidationError
              prefix="Message"
              field="message"
              errors={state.errors}
            />
          </div>

          <div className="form-floating mb-3">
            <input
              id="email"
              name="email"
              type="email"
              className="form-control"
              placeholder="name@example.com"
              required
            />
            <label htmlFor="floatingInput">Email address</label>
          </div>
          <ValidationError prefix="Email" field="email" errors={state.errors} />
        </div>

        <div className="form-floating mb-3">
          <input
            name="Project"
            id="project"
            type="text"
            className="form-control"
            placeholder="name@example.com"
            required
          />
          <label htmlFor="floatingInput">Project</label>
          <ValidationError
            prefix="Message"
            field="message"
            errors={state.errors}
          />
        </div>

        <div className="form-floating">
          <textarea
            id="message"
            name="Message"
            className="form-control"
            placeholder="Leave a comment here"
            required
          ></textarea>
          <label htmlFor="floatingTextarea2">Comments</label>
          <ValidationError
            prefix="Message"
            field="message"
            errors={state.errors}
          />
        </div>
      </div>
      <button className="form-btn" type="submit" disabled={state.submitting}>
        SEND MESSAGE
      </button>
    </form>
  );
}

const Home = () => {
  const contactSectionRef = useRef(null);
  const scrollToContact = () => {
    contactSectionRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const gallerySectionRef = useRef(null);
  const scrollToGallery = () => {
    gallerySectionRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const serviceSectionRef = useRef(null);
  const scrollToService = () => {
    serviceSectionRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const aboutSectionRef = useRef(null);
  const scrollToAbout = () => {
    aboutSectionRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const homeSectionRef = useRef(null);
  const scrollToHome = () => {
    homeSectionRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="home-content">
      <Navbar expand="lg" className="" id="nav">
        <Container>
          <Navbar.Brand
            as={Link}
            to=""
            href="#"
            id="navbar-brand"
            onClick={scrollToHome}
          >
            <img src="\Images\olazsports.png" alt="" id="nav-icon" />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="navbar-dark"
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="m-auto">
              <Nav.Link
                as={Link}
                to=""
                href="#"
                className="nav-link"
                onClick={scrollToHome}
              >
                HOME
              </Nav.Link>

              <Nav.Link
                as={Link}
                to=""
                href="div#about"
                className="nav-link"
                onClick={scrollToAbout}
              >
                ABOUT US
              </Nav.Link>

              <Nav.Link
                as={Link}
                to=""
                href="#proposals"
                className="nav-link"
                onClick={scrollToService}
              >
                SERVICES
              </Nav.Link>

              <Nav.Link
                as={Link}
                to=""
                href="#contactus"
                className="nav-link"
                onClick={scrollToContact}
              >
                CONTACT US
              </Nav.Link>
              <Nav.Link
                as={Link}
                to=""
                href="#gallery"
                className="nav-link"
                onClick={scrollToGallery}
              >
                GALLERY
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div ref={homeSectionRef}></div>
      <div className="Home">
        <h1 className="business-name" data-aos="zoom-in">
          <img src="" alt="" />
          <p id="biz-name">
            <span id="ola">OLAZ</span>
            <span id="sports">SPORTS</span> INTERMEDIARY{" "}
          </p>
        </h1>
        <h1 className="business-desc" data-aos="fade-up">
          Energy Sourcing Services Provider.
        </h1>
        <div className="home-buttons d-flex justify-content-center">
          <div>
            {/* <Button size="lg" className="home-btn" data-aos="zoom-in">
              COMING SOON
            </Button> */}
          </div>
          <div>
            <Button
              size="lg"
              id="home-contact"
              className="home-btn"
              data-aos="zoom-in"
              onClick={scrollToContact}
            >
              CONTACT US
            </Button>
          </div>
        </div>
      </div>

      <div className="section-2 d-flex justify-content-center">
        <div
          className="d-flex flex-column s-card"
          data-aos="fade-up"
          data-aos-duration="500"
        >
          {" "}
          <div>
            <Icon
              icon="fa-regular:handshake"
              width="50"
              height="50"
              color="#996822"
            />
          </div>
          <div>
            <p className="card-header mb-2">Integrity</p>
            <p className="card-para">
              We are guided daily by our unwavering commitment towards
              fulfilling our obligations to our clients.
            </p>
          </div>
        </div>
        <div
          className="d-flex flex-column s-card"
          data-aos="zoom-in"
          data-aos-duration="500"
        >
          {" "}
          <div>
            <Icon
              icon="fluent:target-arrow-24-filled"
              width="50"
              height="50"
              color="#996822"
            />
          </div>
          <div>
            <p className="card-header mb-2">Customer Focus</p>
            <p className="card-para">
              We apply creativity and flexibility in meeting the needs of our
              clients which culminates in their satisfaction
            </p>
          </div>
        </div>
        <div
          className="d-flex flex-column s-card"
          data-aos="fade-up"
          data-aos-duration="500"
        >
          {" "}
          <div>
            <Icon
              icon="fa-regular:thumbs-up"
              width="50"
              height="45"
              color="#996822"
            />
          </div>
          <div>
            <p className="card-header mb-2">Excellent</p>
            <p className="card-para">
              We constantly optimize our service delivery process to give the
              best service experience to our clients around the world
            </p>
          </div>
        </div>
      </div>

      <div className="whatsapp-icon" data-aos="fade-up" data-aos-duration="500">
        <a href="https://wa.link/44v230">
          <Icon
            icon="logos:whatsapp-icon"
            color="#996822"
            width="40"
            height="40"
          />
        </a>
      </div>

      <div ref={aboutSectionRef}></div>
      <div
        className="about-us-section d-flex container"
        data-aos="fade-up"
        data-aos-duration="500"
      >
        <div
          className="about-us-left"
          data-aos="fade-right"
          data-aos-duration="500"
        >
          <div className="crane-pic">
            <img src="\Images\crane.jpg" alt="" />
          </div>
          <div className="group-pic">
            <img src="\Images\group.JPG" alt="" />
          </div>
        </div>
        <div className="about-us-right d-flex flex-column">
          <div className="about-us-text">
            <p id="about-us-text">About Us</p>
          </div>
          <div className="over-20">
            <p id="over-20">Over 10 Years of Proven Track Record</p>
          </div>
          <div
            className="about-us-desc"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <p id="about-us-desc">
              OlazSports Intermediary Limited Head Office Services (hereinafter
              "OlazSports intermediary limited") is a Business Process
              Outsourcing (BPO) service provider for it's "Principal". The
              Principal of OlazSports intermediary limited is a co-mandate of
              the Primary Mandate of the Refineries. The principal's information
              is found at the latter portion of the Soft Corporate Offer (SCO).
              OlazSports intermediary provides order-taking services to support
              Buyers and Buyer's Mandate. OlazSports intermediary limited is
              part of the chain of intermediaries of the Seller-side Channel.
            </p>
          </div>

          <div className="statistics d-flex justify-content-between">
            <div
              className="statistics-left d-flex flex-column"
              data-aos="fade-up"
              data-aos-duration="500"
            >
              <div className="left-top">
                <div>
                  <p className="statistic-header">100 +</p>
                </div>
                <div>
                  <p className="statistics-text">Successful Projects</p>
                </div>
              </div>
              <div className="left-bottom">
                <div>
                  <p className="statistic-header">100 %</p>
                </div>
                <div>
                  <p className="statistics-text">Customer Satisfaction</p>
                </div>
              </div>
            </div>
            <div
              className="statistics-right d-flex flex-column"
              data-aos="fade-up"
              data-aos-duration="500"
            >
              <div className="right-top">
                <div>
                  <p className="statistic-header">10 +</p>
                </div>
                <div>
                  <p className="statistics-text">Year of experience</p>
                </div>
              </div>
              <div className="right-bottom">
                <div>
                  <p className="statistic-header">100 %</p>
                </div>
                <div>
                  <p className="statistics-text">CSR Compliant</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="services d-flex">
        <div className="services-left d-flex flex-column">
          <div className="services-text">
            <p className="services-header" data-aos="zoom-in">
              We offer <span id="superior">superior</span> services
            </p>
          </div>
          <div className="services-para" data-aos="zoom-in">
            <p className="services-para">
              Our company prides itself on the full utilization of the relevant
              experiences garnered in over 10 years of actively participating in
              all oil sector, and the passion, and the dedication, and knowledge
              of our employees who make strides towards realizing our company's
              goals. OlazSports Intermediary limited processes the Letters of
              Intent (LOI) or Irrevocable Confirmed Purchases Orders (ICPO) from
              the Buyer-side Channel towards the Seller-side Channel. OlazSports
              Intermediary issues the Soft Corporate Offer (SCO) based on the
              pricing provided by its principal. OlazSports Intermediary relays
              the instruction from the Principal to the buyers Mandate.
            </p>
          </div>
        </div>
      </div>

      <div ref={serviceSectionRef}></div>
      <div className="core-services-section container">
        <div
          className="core-services-header"
          data-aos="fade-up"
          data-aos-duration="500"
        >
          <p className="core-service-head">
            Our <span id="core">Core</span> Services
          </p>
          <p className="core-service-para mb-5">
            We have diversified our offerings to include Transportation
            services, Oil and Gas exploration, Real Estate and Property
            Management, Import and Export Services, Health Software and
            Equipment Sales and Diversifying Operations.
          </p>
        </div>

        <div className="core-services d-flex">
          <div
            className="services-column d-flex flex-column"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <div className="service-container d-flex flex-column">
              <div className="service-icon">
                <Icon
                  icon="mdi:cart-sale"
                  color="#996822"
                  width="50"
                  height="50"
                />
              </div>
              <div className="service-head mb-1">Diversifying Operations</div>
              <div className="service-para">
                We partake in contracting, trade, marketing, supply, sales,
                distribution, commission agency, manufacturing, and aligned
                activities for strategic goals.
              </div>
            </div>
            <div className="service-container d-flex flex-column">
              <div className="service-icon">
                <Icon
                  icon="iconoir:healthcare"
                  color="#996822"
                  width="50"
                  height="50"
                />
              </div>
              <div className="service-head mb-1">
                Health Software & Equipment Sales
              </div>
              <div className="service-para">
                We specialize in health software development, ICT solutions,
                resource management, database operations, and medical equipment
                sales.
              </div>
            </div>
          </div>

          <div
            className="services-column d-flex flex-column"
            data-aos="fade-up"
            data-aos-duration="900"
          >
            <div className="service-container d-flex flex-column">
              <div className="service-icon">
                <Icon
                  icon="material-symbols:transportation-outline"
                  color="#996822"
                  width="50"
                  height="50"
                />
              </div>
              <div className="service-head mb-1">Transportation Services</div>
              <div className="service-para">
                We offer ground transport services, including cargo, shuttle,
                vehicle ownership, haulage, charter, and agency roles.
              </div>
            </div>
            <div className="service-container d-flex flex-column">
              <div className="service-icon">
                <Icon
                  icon="mdi:estate"
                  color="#996822"
                  width="50"
                  height="50"
                />
              </div>
              <div className="service-head">
                Real Estate & Property Management
              </div>
              <div className="service-para">
                We focuse on real estate, property management, development, and
                land acquisition while employing estate managers and solicitors.
              </div>
            </div>
          </div>

          <div
            className="services-column d-flex flex-column"
            data-aos="fade-up"
            data-aos-duration="1300"
          >
            <div className="service-container d-flex flex-column">
              <div className="service-icon">
                <Icon
                  icon="fa6-solid:oil-well"
                  color="#996822"
                  width="50"
                  height="50"
                />
              </div>
              <div className="service-head mb-1">Oil & Gas exploration</div>
              <div className="service-para">
                We conduct oil and gas exploration, refinery operation,
                marketing of petroleum products, oil field services, and
                equipment supply.
              </div>
            </div>
            <div className="service-container d-flex flex-column">
              <div className="service-icon">
                <Icon
                  icon="icon-park-outline:import-and-export"
                  color="#996822"
                  width="50"
                  height="50"
                />
              </div>
              <div className="service-head mb-1">Import & Export Services</div>
              <div className="service-para">
                We specialize in import/export and conduct various related
                operations: contracting, logistics, supplies, trade, marketing,
                distribution, commission agency, and manufacturer
                representation.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ethical-conduct-section d-flex mt-5 container">
        <div
          className="ethical-left d-flex flex-column"
          data-aos="zoom-in"
          data-aos-duration="600"
        >
          <div className="ethical-text mb-2">Ethical Conduct</div>
          <div className="ethical-header mb-3">
            Principles and Ethics is at the core of our operations
          </div>
          <div className="ethical-para mb-4">
            We are committed to conducting business in an ethical way, and
            without the use of corrupt practices to obtain undue advantage for
            our company. We ensure that all our activities remain consistent
            with our internal policies and align with regulatory provisions and
            the applicable laws and regulations that exist in the locations that
            we do business.
          </div>
        </div>
        <div
          className="ethical-right"
          data-aos="fade-up"
          data-aos-duration="600"
        >
          <div className="ethical-pic-bg">
            <img src="\Images\good-2.jpg" alt="" />
          </div>
          <div className="ethical-pic">
            <img src="\Images\ethical.jpg" alt="" />
          </div>
        </div>
      </div>

      <div
        className="regulatory-compliance d-flex container"
        data-aos="fade-up"
        data-aos-duration="500"
      >
        <div
          className="regulatory-left"
          data-aos="fade-right"
          data-aos-duration="500"
        >
          <div className="tanker-pic">
            <img src="\Images\tanker-1.jpg" alt="" />
          </div>
          <div className="ship-pic">
            <img src="\Images\ship.jpg" alt="" />
          </div>
        </div>
        <div className=" regulatory-right d-flex flex-column">
          <div className="about-us-text">
            <p id="about-us-text">Regulatory Compliance</p>
          </div>
          <div className="over-20">
            <p id="over-20">Compliance to official regulatory bodies</p>
          </div>
          <div
            className="about-us-desc"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <p id="about-us-desc">
              We are compliant to all regulatory requirements in our line of
              business. We monitor regulatory changes in order for us to
              maintain compliance to state, federal, and international laws.
            </p>
          </div>
        </div>
      </div>

      <div className="HSE-section ethical-conduct-section d-flex container">
        <div
          className="ethical-left d-flex flex-column"
          data-aos="zoom-in"
          data-aos-duration="600"
        >
          <div className="ethical-text mb-2">HSE</div>
          <div className="ethical-header mb-3">
            Health, Safety, and Environment
          </div>
          <div className="ethical-para mb-4">
            OlazSports Intermdeiary works to maintain a safe, incident-free
            workplace, with no injury to any of our employees or other people
            with whom we have direct or indirect relationship. We prioritize the
            well-being of our employees through our support to them with
            incentives and benefits to enhance their welfare.
          </div>
        </div>
        <div
          className="ethical-right"
          data-aos="fade-up"
          data-aos-duration="600"
        >
          <div className="ethical-pic-bg">
            <img src="\Images\hse-2.jpg" alt="" />
          </div>
          <div className="ethical-pic">
            <img src="\Images\HSE.jpeg" alt="" />
          </div>
        </div>
      </div>

      <div ref={gallerySectionRef}></div>
      <div className=" gallery-section container">
        <div
          className="core-services-header"
          data-aos="fade-up"
          data-aos-duration="500"
        >
          <p className="core-service-head">
            Our <span id="core">Gallery</span>
          </p>
          <p className="core-service-para mb-5">
            A sneak peak into our operations
          </p>
        </div>

        <div className="desktop-gallery">
        <div className="core-services d-flex mb-4">
          <div
            className="services-column d-flex flex-column"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <div className="service-container d-flex flex-column">
              <img src="\Images\gallery-1.JPG" alt="" />
            </div>
            <div className="service-container d-flex flex-column">
              <img src="\Images\g-2.JPG" alt="" />
            </div>
          </div>

          <div
            className="services-column d-flex flex-column"
            data-aos="fade-up"
            data-aos-duration="900"
          >
            <div className="service-container d-flex flex-column">
              <img src="\Images\g-3.JPG" alt="" />
            </div>
            <div className="service-container d-flex flex-column">
              <img src="\Images\g-4.JPG" alt="" />
            </div>
          </div>

          <div
            className="services-column d-flex flex-column"
            data-aos="fade-up"
            data-aos-duration="1300"
          >
            <div className="service-container d-flex flex-column">
              <img src="\Images\g-5.JPG" alt="" />
            </div>
            <div className="service-container d-flex flex-column">
              <img src="\Images\g-6.JPG" alt="" />
            </div>
          </div>
        </div>

        <div className="core-services d-flex">
          <div
            className="services-column d-flex flex-column"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <div className="service-container d-flex flex-column">
              <img src="\Images\g-7.JPG" alt="" />
            </div>
            <div className="service-container d-flex flex-column">
              <img src="\Images\g-8.JPG" alt="" />
            </div>
          </div>

          <div
            className="services-column d-flex flex-column"
            data-aos="fade-up"
            data-aos-duration="900"
          >
            <div className="service-container d-flex flex-column">
              <img src="\Images\g-9.JPG" alt="" />
            </div>
            <div className="service-container d-flex flex-column">
              <img src="\Images\g-10.JPG" alt="" />
            </div>
          </div>

          <div
            className="services-column d-flex flex-column"
            data-aos="fade-up"
            data-aos-duration="1300"
          >
            <div className="service-container d-flex flex-column">
              <img src="\Images\g-11.JPG" alt="" />
            </div>
            <div className="service-container d-flex flex-column">
              <img src="\Images\g-12.JPG" alt="" />
            </div>
          </div>
        </div>
        </div>

        {/* mobile carousel */}

        <div className="mobile-carousel">
          <div
            id="carouselExampleInterval"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active" data-bs-interval="2000">
                <img src="\Images\gallery-1.JPG" className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item" data-bs-interval="2000">
                <img src="\Images\g-12.JPG" className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item" data-bs-interval="2000">
                <img src="\Images\g-2.JPG" className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item" data-bs-interval="2000">
                <img src="\Images\g-3.JPG" className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item" data-bs-interval="2000">
                <img src="\Images\g-4.JPG" className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item" data-bs-interval="2000">
                <img src="\Images\g-5.JPG" className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img src="\Images\g-6.JPG" className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item" data-bs-interval="2000">
                <img src="\Images\g-7.JPG" className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item" data-bs-interval="2000">
                <img src="\Images\g-8.JPG" className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item" data-bs-interval="2000">
                <img src="\Images\g-9.JPG" className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item" data-bs-interval="2000">
                <img src="\Images\g-10.JPG" className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item" data-bs-interval="2000">
                <img src="\Images\g-11.JPG" className="d-block w-100" alt="..." />
              </div>
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleInterval"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleInterval"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div>

      <div ref={contactSectionRef}></div>

      <div id="#contact" className="contact-me-section container">
        <div className="contact-head">
          <p id="contact-me">
            Contact <span id="Us">Us</span>
          </p>
          <p id="get-in-touch">Get in touch</p>
        </div>

        <div className="contact d-flex">
          <div className="contact-left d-flex flex-column">
            <div className="contact-option d-flex" data-aos="fade-up-right">
              <div className="contact-icon">
                <Icon icon="mi:call" color="#996822" width="40" height="40" />
              </div>
              <div className="contact-details d-flex flex-column">
                <div className="contact-header">Call Us</div>
                <div className="contact-dets">+33 6 84 59 98 77</div>
              </div>
            </div>

            <div className="contact-option d-flex" data-aos="fade-up-right">
              <div className="contact-icon">
                <Icon
                  icon="material-symbols:mail-outline"
                  color="#996822"
                  width="40"
                  height="40"
                />
              </div>
              <div className="contact-details d-flex flex-column">
                <div className="contact-header">Email Us</div>
                <div className="contact-dets">olazsportsinter@gmail.com</div>
              </div>
            </div>

            <div className="contact-option d-flex" data-aos="fade-up-right">
              <div className="contact-icon">
                <Icon
                  icon="akar-icons:location"
                  color="#996822"
                  width="40"
                  height="40"
                />
              </div>
              <div className="contact-details d-flex flex-column">
                <div className="contact-header">Location</div>
                <div className="contact-dets">Worldwide</div>
              </div>
            </div>
          </div>
          <div
            className="contact-right"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
